import React from 'react'
import { ATTextWithLabelProps } from './FormComponentProps'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const ATTextWithLabel: React.FC<ATTextWithLabelProps> = ({
  label,
  value = '--',
  showBorder = true,
}) => {
  const { t } = useTranslation(['translation'])
  return (
    <Row xs={12} className="at-text-with-label">
      <Col xs={4} className="at-text-with-label__label">
        {label ? t(`${label}`) : ''}
      </Col>
      <Col xs={8} className="at-text-with-label__value">
        {value}
      </Col>
    </Row>
  )
}

export default ATTextWithLabel
